import { createFileRoute } from '@tanstack/react-router';

import { AuditDashboardPage } from '@/features/audit-workflow/components/AuditDashboardPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.auditDashboard'),
  }),
  component: AuditDashboardRoute,
});

function AuditDashboardRoute() {
  return <AuditDashboardPage />;
}
